<template>
    <div class="imageBox">
        <div class="innerBox">
            <div class="newImg">
                <p class="newProvince">{{ province }}</p>
                <img
                    src="https://file.gkzzd.cn/www/gkzzd/uploads/20241106/534ffce2e01f418683ac36ee0b402bd1.png"
                    alt=""
                    class="WH-100"
                />
            </div>
            <div style="flex: 1">
                <a :href="banner.link" target="_blank">
                    <img
                        :src="banner.img"
                        class="WH-100"
                        @click="getAdsClick(banner.ads_id)"
                    />
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        headerProvince: String,
    },
    data() {
        return {
            banner: {},
            province:''
        }
    },
    watch: {
        headerProvince: {
            handler(newVal) {
                this.province = newVal;
                this.getHomePageAd();
            },
            immediate: true,
        },
    },
    methods: {
        async getHomePageAd() {
            const res = await this.$http.fetch("/api/homepage/homePageAd", {
                sf: this.province,
            });
            if (res.status == 200) {
                let data = res.data;
                this.banner = data.banner
                this.$emit("homePageAd", data);
            }
        },
        async getAdsClick(adsID) {
            const res = await this.$http.fetch("/api/homepage/adsClick", {
                sf: this.province,
                ads_id: adsID,
            });
        },
    },
    mounted() {},
    created() {},
}
</script>
<style lang="scss" scoped>
.imageBox {
    height: 170px;
    background-color: #3c78ff;
    padding: 15px 0;
    box-sizing: border-box;
    .innerBox {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        .newImg {
            width: calc(100% / 4);
            position: relative;
            .newProvince {
                position: absolute;
                top: 50%;
                left: 13%;
                transform: translate(-50%, -50%);
                background: #d60707;
                writing-mode: vertical-rl; /* 竖排，从右到左 */
                font-size: 20px;
                padding: 5px 2px;
                font-weight: bold;
                color: #fff;
            }
        }
    }
}
</style>